export const enum ResultCode {
	WORKED = 'WORKED',
	WRONG_PASSWORD = 'WRONG_PASSWORD',
	BAD_READ = 'BAD_READ',
	FS_ERROR = 'FS_ERROR',
	BAD_PARSE = 'BAD_PARSE',
	BAD_FORMAT = 'BAD_FORMAT',
	BAD_STATE = 'BAD_STATE',
	UNSUPPORTED = 'UNSUPPORTED',
	NOT_ENCRYPTED = 'NOT_ENCRYPTED',
	ENCRYPTED = 'ENCRYPTED',
	BAD_DECRYPT = 'BAD_DECRYPT',
	BAD_ZIP = 'BAD_ZIP',
	NOT_AVAILABLE = 'NOT_AVAILABLE',
	NOT_RUNNING = 'NOT_RUNNING',
	INVALID_DATE = 'INVALID_DATE',
	NOT_APPLICABLE = 'NOT_APPLICABLE',

	ERROR = 'ERROR',
	STARTED = 'STARTED',
	READY = 'READY',
	PREMATURE_EXIT = 'PREMATURE_EXIT',
	STOPPED = 'STOPPED',
	TIMEOUT = 'TIMEOUT',
	ABORTED = 'ABORTED',
	INTERRUPTED = 'INTERRUPTED',

	EACCES = 'EACCES',
	ENOENT = 'ENOENT',
	ETXTBSY = 'ETXTBSY',
	ELOOP = 'ELOOP',
	ENAMETOOLONG = 'ENAMETOOLONG',
	EOF = 'EOF',
}
